import React from "react";
import classes from "./storeCheckoutLocatorModal.css";
import getDirectionGoogleMap from "@magento/peregrine/lib/util/getDirectionGoogleMap";
import { sendGTMEvent } from "../../../util/initGTM";
import AvailableIcon from "../../AvailableIcon";
import { useAppContext } from "@magento/peregrine/lib/context/app";
import { FormattedMessage } from 'react-intl';
var StoreActionButtons = props => {
  var {
    store,
    fromPage,
    setOpenInfoWindow,
    closeModal,
    completeButtons,
    rootStyle = {},
    inStock
  } = props;
  var {
    address,
    city,
    country,
    region,
    zipcode,
    latitude,
    longitude,
    bopis_enabled
  } = store;
  var [{
    currentStore
  }, {
    setCurrentStore
  }] = useAppContext();
  var directionButton = /*#__PURE__*/React.createElement("button", {
    className: completeButtons ? classes.getDirectionsCompleteButton : classes.getDirectionButton,
    onClick: () => {
      getDirectionGoogleMap({
        address,
        city,
        country,
        region,
        zipcode,
        lat: latitude,
        lng: longitude
      });
      switch (fromPage) {
        case 'checkout':
          {
            sendGTMEvent({
              eventCategory: 'checkout step 4.1.1 - select a store',
              eventAction: 'Select Other Store Overlay',
              eventLabel: "".concat(store.name, " - get direction"),
              event: 'genericGAEvent'
            });
            break;
          }
      }
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    defaultMessage: 'Get Directions',
    id: 'GetDirection'
  }));
  var selectStoreButton = currentStore && currentStore.store_id === store.store_id ? /*#__PURE__*/React.createElement("div", {
    className: classes.checkingContainer,
    style: completeButtons ? {
      justifySelf: 'flex-start'
    } : {}
  }, /*#__PURE__*/React.createElement(AvailableIcon, {
    type: 'check'
  }), /*#__PURE__*/React.createElement(FormattedMessage, {
    defaultMessage: 'Selected Store',
    id: 'storeSchedule.selectedStore'
  })) : bopis_enabled === "1" && /*#__PURE__*/React.createElement("button", {
    className: classes.selectThisStoreButton,
    onClick: () => {
      setCurrentStore(store);
      setOpenInfoWindow && setOpenInfoWindow(store);
      closeModal && closeModal(false);
      switch (fromPage) {
        case 'checkout':
          {
            sendGTMEvent({
              eventCategory: 'checkout step 4.1.1 - select a store',
              eventAction: 'Select Other Store Overlay',
              eventLabel: "".concat(store.name, " - select store"),
              event: 'genericGAEvent'
            });
            sendGTMEvent({
              eventCategory: 'checkout step 4.1.1 - select a store',
              eventAction: 'Sucessful store change',
              eventLabel: "selectedStore: ".concat(store.name),
              stockAvailableNote: inStock,
              selectedStore: store.name,
              event: 'genericGAEvent'
            });
            break;
          }
      }
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    defaultMessage: 'Select this Store',
    id: 'storeSchedule.selectThisStore'
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: classes.storeActionsContainer,
    style: rootStyle
  }, selectStoreButton, directionButton);
};
export default StoreActionButtons;